module.exports = __webpack_public_path__ + "static/img/example_upload.19917e6d.jpg";